import { CheckBox, TextBox } from "devextreme-react";
import React from "react";

const SSOSecurity = ({ value, onValueChange }) => {
  const {
    sso_enabled,
    sso_authority_endpoint,
    sso_directory_id,
    sso_application_id,
  } = value;

  return (
    <div className="mb-5">
      <table className="table table-bordered align-middle mt-1">
        <thead className="table-dark">
          <tr>
            <th scope="col">Setting</th>
            <th scope="col">Value</th>
            <th scope="col">Explanation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Allow Single Sign-On</th>
            <td className="text-center">
              <CheckBox
                value={sso_enabled}
                onValueChanged={(e) => onValueChange(e, "sso_enabled")}
              />
            </td>
            <td>
              Allow the users to sign into Erply through a Single Sign-On
              provider, such as Google G Suite or Azure Active Directory.
            </td>
          </tr>
          <tr>
            <th scope="row">Authority URL</th>
            <td style={{ width: "40%" }}>
              <TextBox
                value={sso_authority_endpoint}
                onValueChanged={(e) =>
                  onValueChange(e, "sso_authority_endpoint")
                }
                valueChangeEvent="keyup"
                showClearButton={true}
              />
            </td>
            <td>
              For Azure, use{" "}
              <a
                href="https://login.microsoftonline.com/"
                target="_blank"
                rel="noreferrer"
              >
                https://login.microsoftonline.com/
              </a>
            </td>
          </tr>
          <tr>
            <th scope="row">Directory ID</th>
            <td>
              {" "}
              <TextBox
                value={sso_directory_id}
                onValueChanged={(e) => onValueChange(e, "sso_directory_id")}
                valueChangeEvent="keyup"
                showClearButton={true}
              />
            </td>
            <td style={{ width: "30%" }}>
              Enter the ID of your company directory (tenant ID). This field is
              required for setting up Single Sign-On, and ensures that only
              employees listed in your company directory (and not people from
              other companies) can sign into your Erply account.
            </td>
          </tr>
          <tr>
            <th scope="row">Application ID</th>
            <td>
              {" "}
              <TextBox
                value={sso_application_id}
                onValueChanged={(e) => onValueChange(e, "sso_application_id")}
                valueChangeEvent="keyup"
                showClearButton={true}
              />
            </td>
            <td>ID assigned to Erply in your SSO settings.</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SSOSecurity;
